const CODE_VERIFIER_STORAGE_KEY = 'matatika_oauth2_code_verifier'
const OAUTH_PARAMS_STORAGE_KEY = 'matatika_oauth2_params'

export type OAuthParams = Record<string, string>

function toOAuthParams(params: URLSearchParams): OAuthParams | null {
  if (!(params instanceof URLSearchParams)) {
    return null
  }

  const parsedParams: OAuthParams = {}

  for (const [key, value] of params.entries()) {
    parsedParams[key] = value
  }

  return parsedParams
}

export function storeOAuthParams(params: URLSearchParams): void {
  const parsedParams = toOAuthParams(params)

  if (!parsedParams)
    return

  if (!Object.keys(parsedParams).length) {
    return
  }

  localStorage.setItem(OAUTH_PARAMS_STORAGE_KEY, JSON.stringify(parsedParams))

}

export function fetchOAuthParams(): OAuthParams | null {
  const params = localStorage.getItem(OAUTH_PARAMS_STORAGE_KEY)

  if (params) {
    localStorage.removeItem(OAUTH_PARAMS_STORAGE_KEY)

    try {
      return JSON.parse(params) as OAuthParams
    } catch {
      return null
    }
  }

  return null
}

export function storeCodeVerifier(codeVerifier: string): void {
  localStorage.setItem(CODE_VERIFIER_STORAGE_KEY, codeVerifier)
}

export function fetchCodeVerifier(): string | null {
  const codeVerifier = localStorage.getItem(CODE_VERIFIER_STORAGE_KEY)
  localStorage.removeItem(CODE_VERIFIER_STORAGE_KEY)
  return codeVerifier
}
